import parse from "html-react-parser"

import iconArrowDownThin from "images/icons/icon-arrow-down-thin.svg?raw"

import styles from "./conversation.module.scss"

interface Props {
  onClick: () => void
}

const BackToLatestToast = ({ onClick }: Props) => (
  <button type="button" className={styles["back-to-latest"]} onClick={onClick} data-testid="back-to-latest-toast">
    <span className={styles["back-to-latest__label"]}>Back to most recent</span>
    <span className={styles["back-to-latest__icon"]} aria-hidden="true">
      {parse(iconArrowDownThin)}
    </span>
  </button>
)

export default BackToLatestToast
